// Dependencies
import { useState, useEffect } from "react";
import _cx from 'classnames';
import _ from 'lodash';

// Hooks
import useDebug from "../hooks/Wooptima/Debug";
import useAPI from '../hooks/Api';

// Components
import OptionSelect from './OptionSelect';

// Types
import { Types } from '../utils/types';

 
const App = () => {

    // Component | States
    const [servicesData, setServicesData] = useState<Types.FormGroup|null>(null)

    // Component | Hooks
    const { getServicesData } = useAPI();
    const { logDebugMessage } = useDebug('App');

    // Get formSections data from the API
    useEffect(() => {

        getServicesData() 
        .then( (response) => {
            setServicesData( response?.data ); 
        })
        .catch((errors) => {
            // TODO: Handle errors
            logDebugMessage(errors);
        })

    }, []);

    if ( ! servicesData ) {
        return null;
    } 

    return (
        <div className="es-services">
            <h2 className="es-services__heading">{servicesData?.label}</h2>
            <div className="es-services__list">
                <OptionSelect hasIcons={true} options={servicesData?.options} />
            </div>
        </div>
    );

}

export default App; 